import React ,{useEffect} from "react";
import { MdEmail } from "react-icons/md";
import { IoChatbox } from "react-icons/io5";
import { Link } from "react-router-dom";
import {useAuthContext} from '../hooks/useAuthContext';
import dayjs from 'dayjs';
import { jwtDecode } from "jwt-decode";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import {Helmet} from "react-helmet";
import { useLogout } from "../hooks/useLogout";
import { openSupport } from "../lib/support";

function Support() {
const navigate = useNavigate()
const {logout} = useLogout();
    const {user,dispatch} = useAuthContext()
    useEffect(() => {
      const users = Cookies.get('token')

      if(!users ){
        logout()
      }
try{

        const User = jwtDecode(user)
        const checkToken = async() =>{
          const isExpired = dayjs.unix(User.exp).diff(dayjs())< 1;
        
        if(!isExpired){
                        
        }else{
          
          const response = await fetch(`${process.env.REACT_APP_API_URL || "http://localhost:4000"}/api/user/refresh-token`, {
            method: 'GET',
            headers: {'Content-Type':'application/json',
        },
        credentials:'include'
        })
      if(response.status === 200){
         const json = await response.json()
         dispatch({ type: 'LOGIN', payload: json.token })
         navigate("/")
      }else{
        logout()
      }
        }
      
      }
        
      
      
      checkToken()
    }catch(e){
      if(e.message.includes("Invalid token specified")){
        logout()
      }
    }
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [])
    if(user){

    
  return (
    <div className=" text-black min-h-screen lg:w-3/4 md:w-3/4 sm:w-3/4 w-2/3 mx-auto ">
       <Helmet>
                <meta charSet="utf-8" />
                <title>Support - Content Flash AI</title>
               <meta name="description" content="Content Flash AI is an AI based content generator. Generate blogs, emails,etc in seconds."/>
            </Helmet>
             <h1 className="dark:text-white  py-2 text-left font-Rajdhani bg-gradient-to-r from-black from 1% via-red-500  to-orange-600 to-100% inline-block text-transparent bg-clip-text">Help & Support </h1>
             <div class="grid md:grid-cols-2 gap-2 content-center mt-5 ">
  <div className="border p-2 rounded">
    <p className="flex font-normal font-Rajdhani text-xl items-center dark:text-white"><MdEmail size={30} className="mr-1" />Email Us</p>
    <p className="font-normal font-Rajdhani text-xl dark:text-white">support@contentflashai.com</p>
  </div>

  <div className="border p-2 rounded">
  <p className="flex font-normal font-Rajdhani text-xl items-center dark:text-white"><IoChatbox size={30} className="mr-1" />Chat with us</p>
  <button onClick={openSupport} className="btn dark:bg-[#818998] dark:text-white dark:bg-none dark:rounded-2xl dark:hover:scale-105 dark:hover:bg-[#818998] dark:hover:text-white text-white  bg-gradient-to-r from-orange-700 to-orange-600  hover:scale-105" >
                 Chat now
                </button>
  </div>
</div>

{/* Billing / payment help — the churn-critical path */}
<div className="mt-4 rounded-lg border border-indigo-200 dark:border-indigo-700/50 bg-indigo-50/60 dark:bg-indigo-900/15 p-4 dark:text-white">
  <p className="font-Rajdhani text-xl font-semibold">Payment or billing issue?</p>
  <p className="text-sm text-gray-600 dark:text-gray-300 mt-1">
    If a payment failed or your plan looks wrong, update your payment method — your data and forms are safe in the meantime.
  </p>
  <div className="flex flex-wrap gap-2 mt-3">
    <Link to="/settings/billing" className="px-4 py-2 rounded-lg bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-semibold no-underline">Fix payment / manage billing</Link>
    <button onClick={openSupport} className="px-4 py-2 rounded-lg border border-indigo-300 dark:border-indigo-600 text-indigo-700 dark:text-indigo-300 text-sm font-semibold">Message support</button>
  </div>
  <p className="text-xs text-gray-500 dark:text-gray-400 mt-3">Typical reply time: a few hours (Mon–Fri, 9am–5pm IST). AppSumo customers — we've got you, just reach out.</p>
</div>

<div className="max-w-screen-xl mx-auto pt-12 pb-16 sm:pt-16 sm:pb-20 px-4 sm:px-6 lg:pt-20 lg:pb-28 lg:px-8 dark:text-white">
        <h2 className="text-3xl leading-9 font-extrabold font-Rajdhani text-gray-900 text-center dark:text-white">
            Frequently asked questions
        </h2>
        <div className="mt-6 border-t-4 border-gray-100 pt-10 ">
            <div className="grid grid-cols-1 md:grid-cols-2 md:gap-x-8 md:gap-y-12  ">
                <dl>
                    <dt className="font-medium font-Rajdhani leading-6 text-gray-900 text-lg mt-4 dark:text-white">Can I change my plan at any time?</dt>
                    <dd className="mt-4">
                        <p className="leading-6 text-base text-gray-500 dark:text-white font-medium">
                            Yes, you can upgrade or downgrade your plan any time.
                        </p>
                    </dd>
                </dl>

                <dl>
                    <dt className="font-medium font-Rajdhani leading-6 text-gray-900 text-lg mt-4 dark:text-white ">
                    How do I cancel my subscription?
                    </dt>
                    <dd className="mt-4">
                        <p className="leading-6 text-base text-gray-500 dark:text-white font-medium">
                        You can easily cancel your subscription at any time by going to your account settings.
                        </p>
                    </dd>
                </dl>

                <dl>
                    <dt className="font-medium font-Rajdhani leading-6 text-gray-900 text-lg mt-4 dark:text-white">
                    What payment methods are accepted?
                    </dt>
                    <dd className="mt-4">
                        <p className="leading-6 text-base text-gray-500 dark:text-white font-medium">
                        We support all major credit cards and debit cards. Your payment method is secured by Razorpay for your privacy and security. Please contact us.
                        </p>
                    </dd>
                </dl>

                <dl>
                    <dt className="font-medium font-Rajdhani leading-6 text-gray-900 text-lg mt-4 dark:text-white ">
                        What are the hours of operation?
                    </dt>
                    <dd className="mt-4">
                        <p className="leading-6 text-base text-gray-500 dark:text-white font-medium">
                            Our customer service department is open Monday-Friday, 9am-5pm IST. Messages sent outside these hours are answered first thing the next working day.
                        </p>
                    </dd>
                </dl>

                <dl>
                    <dt className="font-medium font-Rajdhani leading-6 text-gray-900 text-lg mt-4 dark:text-white">
                        My payment failed — what happens to my account?
                    </dt>
                    <dd className="mt-4">
                        <p className="leading-6 text-base text-gray-500 dark:text-white font-medium">
                            Nothing is deleted. Razorpay retries automatically, and you'll see a banner with a “Fix payment” button that takes you to <Link to="/settings/billing" className="text-indigo-600 dark:text-indigo-400">billing</Link>. Update your card there, or message us and we'll sort it out.
                        </p>
                    </dd>
                </dl>

                <dl>
                    <dt className="font-medium font-Rajdhani leading-6 text-gray-900 text-lg mt-4 dark:text-white">
                        I bought a lifetime deal on AppSumo — how do I get help?
                    </dt>
                    <dd className="mt-4">
                        <p className="leading-6 text-base text-gray-500 dark:text-white font-medium">
                            Your lifetime access never expires. Use the chat bubble or “Message support” — mention it's an AppSumo code and we'll prioritise it.
                        </p>
                    </dd>
                </dl>

                <dl>
                    <dt className="font-medium font-Rajdhani leading-6 text-gray-900 text-lg mt-4 dark:text-white">
                        Can I use my own OpenAI key?
                    </dt>
                    <dd className="mt-4">
                        <p className="leading-6 text-base text-gray-500 dark:text-white font-medium">
                            Yes — add your key under <Link to="/settings/billing" className="text-indigo-600 dark:text-indigo-400">billing</Link>. AI generation and analysis then run on your key and don't count toward your monthly limits.
                        </p>
                    </dd>
                </dl>
            </div>
        </div>
    </div>
    </div>
  );
    }else{
      return navigate("/")
    }
}

export default Support;